import React from 'react';
import { OrderedMap } from 'immutable';
import shallowCompare from '../../lib/shallowCompare';
import CollectionTile from '../CollectionTile';
import styles from './index.sass';

class CollectionsList extends React.Component {
  static propTypes = {
    entities: React.PropTypes.instanceOf(OrderedMap),
    loading: React.PropTypes.bool
  };

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  renderCollections() {
    if(this.props.loading) {
      return <span className="loading-spinner--teal" style={{display: 'block', marginTop: 60}} />;
    }
    return this.props.entities.toList().map(collection => {
      if (collection.is_private) {
        return null;
      }
      let tileProps = {
        collection: collection,
        key: collection.id
      };
      return <CollectionTile {...tileProps} />;
    });
  }

  render() {
    return (
      <div className={styles.collections}>
        <h1 className={styles.header}>Collections</h1>
        <div className={styles.list}>
          {this.renderCollections()}
        </div>
      </div>
    );
  }
}

export default CollectionsList;



// WEBPACK FOOTER //
// banquet/components/CollectionsList/index.js